import { Col, Form, Input } from "antd";


function ManifestCountryComponent() {

    return (
        <>
            <Col>
                <Form.Item
                    name='originCountry' labelCol={{ span: 24 }} className='select-width'
                    label={<label className="labelLeftCol">Origin Country:</label>}

                >
                    {/* <Select onSelect={() => { }} className='select-width' disabled
                        showSearch
                        filterOption={(input, option) =>
                            (option!.children as unknown as string)?.toLocaleLowerCase()?.includes(input?.toLocaleLowerCase())
                        }
                    >
                        {
                            countryListMemo?.map((country: any) => (
                                <React.Fragment key={country?.id}>
                                    <Select.Option value={country?.id}>{country?.value}</Select.Option>
                                </React.Fragment>
                            ))
                        }
                    </Select> */}
                    <Input disabled />
                </Form.Item>
                <Form.Item
                    name='originCity' labelCol={{ span: 24 }} className='select-width'
                    label={<label className="labelLeftCol">Origin City:</label>}
                >
                    {/* <Select className='select-width' disabled
                        showSearch
                        filterOption={(input, option) =>
                            (option!.children as unknown as string)?.toLocaleLowerCase()?.includes(input?.toLocaleLowerCase())
                        }
                    >
                        {
                            originListMemo?.map((industry: any) => (
                                <React.Fragment key={industry?.id}>
                                    <Select.Option value={industry?.id}>{industry?.value}</Select.Option>
                                </React.Fragment>
                            ))
                        }
                    </Select> */}
                    <Input disabled />

                </Form.Item>
                <Form.Item
                    name='destinationCountry' labelCol={{ span: 24 }} className='select-width'
                    label={<label className="labelLeftCol">Destination Country:</label>}

                >
                    {/* <Select onSelect={() => { }} className='select-width' disabled
                        showSearch
                        filterOption={(input, option) =>
                            (option!.children as unknown as string)?.toLocaleLowerCase()?.includes(input?.toLocaleLowerCase())
                        }
                    >
                        {
                            countryListMemo?.map((country: any) => (
                                <React.Fragment key={country?.id}>
                                    <Select.Option value={country?.id}  >{country?.value}</Select.Option>
                                </React.Fragment>
                            ))
                        }
                    </Select> */}
                    <Input disabled />

                </Form.Item>
                <Form.Item
                    name='destinationCity' labelCol={{ span: 24 }} className='select-width'
                    label={<label className="labelLeftCol">Destination City</label>}
                >
                    {/* <Select size="middle" className='select-width' disabled>
                        {
                            destinationListMemo?.map((origin: any) => (
                                <React.Fragment key={origin?.id}>
                                    <Select.Option value={origin?.id}  >{origin?.value}</Select.Option>
                                </React.Fragment>
                            ))
                        }
                    </Select> */}
                    <Input disabled />

                </Form.Item>
            </Col>

        </>
    )
}

ManifestCountryComponent.propTypes = {}

export default ManifestCountryComponent
